import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    selectFirstDate,
    selectNextDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { getDateWithTimezone } from 'utils/date-timezone';

const selectLoadSpraySubmissionsParams = createDeepEqualSelector(
    selectFirstDate,
    selectNextDate,
    selectCurrentOrganizationId,
    (firstDate: string, nextDate: string, organizationId) => ({
        organizationId,
        filter: {
            where: {
                createdAt: {
                    $gte: getDateWithTimezone(firstDate),
                    $lt: getDateWithTimezone(nextDate)
                }
            }
        }
    })
);

export { selectLoadSpraySubmissionsParams };
